module.exports = __webpack_public_path__ + "static/media/icon-8.8380495f.svg";